import { render, staticRenderFns } from "./firstSection.vue?vue&type=template&id=46b4bc60"
var script = {}
import style0 from "./firstSection.vue?vue&type=style&index=0&id=46b4bc60&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports